import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
/** @jsxfrag */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { useACTAnalyticsEvents } from '@atlassian/ad-control-toolkit';
import { CLICK_PRIVACY_POLICY_LINK } from '../../common/constants';
import { useAppRecommendationsProvider } from '../../controllers';
import { messages } from '../messages';

// The following spacing units are in pixels because trello has root font size set to 14
const ulStyles = xcss({
  listStyleType: 'disc',
  paddingLeft: 'space.250',
  marginTop: 'space.150'
});
const pStyles = css({
  marginTop: "var(--ds-space-150, 12px)"
});
const ReasonsModalBody = ({
  productId,
  name,
  reasons = []
}) => {
  const {
    onEvents
  } = useAppRecommendationsProvider();
  const {
    createInteractedUIEvent
  } = useACTAnalyticsEvents();
  const onClickPrivacyLink = React.useCallback(() => {
    onEvents === null || onEvents === void 0 ? void 0 : onEvents({
      type: CLICK_PRIVACY_POLICY_LINK,
      itemId: productId,
      analyticsEvent: createInteractedUIEvent({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'adControlsReasonsClose'
      })
    });
  }, [createInteractedUIEvent, onEvents, productId]);
  return jsx(Box, null, jsx(FormattedMessage, _extends({}, messages.reasonsIntro, {
    values: {
      product: jsx("strong", null, name)
    }
  })), jsx(Stack, {
    as: "ul",
    xcss: ulStyles
  }, reasons.map(reason =>
  // eslint-disable-next-line @atlaskit/design-system/prefer-primitives
  jsx("li", {
    key: reason
  }, reason))), jsx("p", {
    css: pStyles
  }, jsx("a", {
    onClick: onClickPrivacyLink,
    href: "https://www.atlassian.com/legal/privacy-policy",
    target: "_blank"
  }, jsx(FormattedMessage, messages.learnMoreAboutDataPolicy))));
};
export default ReasonsModalBody;